export const slugify = (value = "") => {
  if (!value) return "";

  return value
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\//g, " ")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\s+/g, "-");
};

export const deslugify = (slug = "") =>
  slug.replace(/-/g, " ").trim();
